/* istanbul ignore file */
import { getTopBannerContent } from '@noths/polaris-client-banners';
import type { FeatureFlags } from '@noths/polaris-client-feature-flags';
import {
  Environment,
  fetchNavigationContent,
  GlobalNavigation,
} from '@noths/polaris-client-site-chrome-ui';
import * as runtimeProcess from 'process';

import { logger } from 'src/utils/serverLogger';

const { ENV_TYPE } = runtimeProcess.env;

const isProd = ENV_TYPE && ['production', 'staging', 'oldstaging'].includes(ENV_TYPE);

interface GlobalContentOptions {
  featureFlags: FeatureFlags;
  urlPath?: string;
}

export const fetchGlobalContent = async ({ featureFlags, urlPath }: GlobalContentOptions) => {
  const env = isProd ? Environment.Production : Environment.Qa;
  const config = { env, logger };
  const navContentVariantId = featureFlags.nav_content_experiment;
  const contentSource =
    featureFlags[GlobalNavigation.NAME] === GlobalNavigation.PROGRESSIVE_DISCLOSURE
      ? 'dx'
      : 'legacy';

  return Promise.all([
    fetchNavigationContent(config, navContentVariantId, contentSource).catch(() => null),
    getTopBannerContent(config, { urlPath }),
  ]);
};
